module.exports = __webpack_public_path__ + "static/media/06-08.2777c765.png";